/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ClientType } from './ClientType';
import {
    ClientTypeFromJSON,
    ClientTypeFromJSONTyped,
    ClientTypeToJSON,
} from './ClientType';
import type { LegalEntityDetails } from './LegalEntityDetails';
import {
    LegalEntityDetailsFromJSON,
    LegalEntityDetailsFromJSONTyped,
    LegalEntityDetailsToJSON,
} from './LegalEntityDetails';
import type { NaturalPersonDetails } from './NaturalPersonDetails';
import {
    NaturalPersonDetailsFromJSON,
    NaturalPersonDetailsFromJSONTyped,
    NaturalPersonDetailsToJSON,
} from './NaturalPersonDetails';

/**
 * 
 * @export
 * @interface ClientPersonalDetailsViewModel
 */
export interface ClientPersonalDetailsViewModel {
    /**
     * 
     * @type {NaturalPersonDetails}
     * @memberof ClientPersonalDetailsViewModel
     */
    naturalPersonDetails?: NaturalPersonDetails;
    /**
     * 
     * @type {LegalEntityDetails}
     * @memberof ClientPersonalDetailsViewModel
     */
    legalEntityDetails?: LegalEntityDetails;
    /**
     * 
     * @type {ClientType}
     * @memberof ClientPersonalDetailsViewModel
     */
    clientType: ClientType;
}

/**
 * Check if a given object implements the ClientPersonalDetailsViewModel interface.
 */
export function instanceOfClientPersonalDetailsViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "clientType" in value;

    return isInstance;
}

export function ClientPersonalDetailsViewModelFromJSON(json: any): ClientPersonalDetailsViewModel {
    return ClientPersonalDetailsViewModelFromJSONTyped(json, false);
}

export function ClientPersonalDetailsViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClientPersonalDetailsViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'naturalPersonDetails': !exists(json, 'NaturalPersonDetails') ? undefined : NaturalPersonDetailsFromJSON(json['NaturalPersonDetails']),
        'legalEntityDetails': !exists(json, 'LegalEntityDetails') ? undefined : LegalEntityDetailsFromJSON(json['LegalEntityDetails']),
        'clientType': ClientTypeFromJSON(json['ClientType']),
    };
}

export function ClientPersonalDetailsViewModelToJSON(value?: ClientPersonalDetailsViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'NaturalPersonDetails': NaturalPersonDetailsToJSON(value.naturalPersonDetails),
        'LegalEntityDetails': LegalEntityDetailsToJSON(value.legalEntityDetails),
        'ClientType': ClientTypeToJSON(value.clientType),
    };
}

